import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ConstantsService } from './constants.service';
import { getPreferredUserIdentifier } from '../core/constant/user-context.util';

@Injectable({
	providedIn: 'root'
})
export class UsersService {

	constructor( private readonly http  : HttpClient, private readonly  constantsService: ConstantsService) { }

	getUserInfo(toyotaGUID): Observable<any> {
		const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${this.constantsService.baseAPIURL}/aet/getuserinfo/${userIdentifier}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log('data success')),
				catchError(this.handleError<any>('data fails'))
			);
	}

	getUserInfoFreeze(toyotaGUID): Promise<any> {
		const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${this.constantsService.baseAPIURL}/aet/getuserinfo/${userIdentifier}`, httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}


	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(_message: string) {
		console.info('something')
	}


}
